import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { ChildConnectionFormProps } from '../types';
import { PanelistLinkChildConnectionPresentation } from './panelist-link-child-connection.presentation';
import { PanelistLinkChildConnectionVM } from './panelist-link-child-connection.viewmodel';

export const PanelistLinkChildConnectionForm = withViewModel(PanelistLinkChildConnectionPresentation, (props: ChildConnectionFormProps) => {
    const { accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated } = props;
    return new PanelistLinkChildConnectionVM(accountId, eventId, childConnection, parentConnectionDetails, onChildConnectionUpdated);
});